import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";

export default function PerfilTorneosJugados() {
  const { jugadorId } = useParams();
  const [torneos, setTorneos] = useState([]);

  useEffect(() => {
    console.log("jugadorId:", jugadorId); // Depuración
    if (jugadorId) {
      api.get(`/torneosRealizados/${jugadorId}`)
        .then(res => setTorneos(res.data))
        .catch(err => console.error("Error al obtener torneos realizados:", err));
    } else {
      console.error("El ID del jugador no está definido.");
    }
  }, [jugadorId]);

  return (
    <div>
      <h2>Torneos Realizados</h2>
      <table>
        <thead>
          <tr>
            <th>Torneo</th>
            <th>Puntos</th>
            <th>Fecha Inicio</th>
            <th>Fecha Fin</th>
          </tr>
        </thead>
        <tbody>
          {torneos.map(torneo => (
            <tr key={torneo.id}>
              <td>{torneo.torneo_nombre}</td>
              <td>{torneo.puntos}</td>
              <td>{torneo.fecha_inicio}</td>
              <td>{torneo.fecha_fin}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}